<template>
  <el-dialog
    :visible="visible"
    :show-close="false"
    width="60%"
    top="5vh"
    class="edit-detail-dialog"
    center
    @close="handleDialogClose"
    :close-on-click-modal="false">
    <span slot="title" class="title-container">
      <span class="title-text">{{factoryName + $t('factoryLabelPrint.templateContentEditing')}}</span>
      <img
        src="@/assets/close.png"
        class="close-image"
        @click="close"
      />
    </span>
    <el-form class="el-form" :model="form" ref="refForm" :rules="rules" label-width="120px">
      <el-form-item label-width="0">
        <el-col :span="11">
          <el-form-item label="供应商代码:" prop="supplierCode">
            <el-input
              v-model.trim="form.supplierCode"
              name="supplierCode"
              type="text"
              autocomplete="on"
              clearable
              size="small"
              maxlength="64"
            />
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item label="物料代码:" prop="materialCode">
            <el-input
              v-model.trim="form.materialCode"
              name="materialCode"
              type="text"
              autocomplete="on"
              clearable
              size="small"
              maxlength="64"
            />
          </el-form-item>
        </el-col>
      </el-form-item>
      <el-form-item label-width="0">
        <el-col :span="11">
          <el-form-item label="物料名称:" prop="materialName">
            <el-input
              v-model.trim="form.materialName"
              name="materialName"
              type="text"
              autocomplete="on"
              clearable
              size="small"
              maxlength="64"
            />
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item label="规格型号:" prop="specModel">
            <el-input
              v-model.trim="form.specModel"
              name="specModel"
              type="text"
              autocomplete="on"
              clearable
              size="small"
              maxlength="64"
            />
          </el-form-item>
        </el-col>
      </el-form-item>
      <el-form-item label-width="0">
        <el-col :span="11">
          <el-form-item label="数量:" prop="qty">
            <el-input
              v-model.trim.number="form.qty"
              name="qty"
              type="text"
              autocomplete="on"
              clearable
              size="small"
              maxlength="9"
            />
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item label="订单号:" prop="orderNo">
            <el-input
              v-model.trim="form.orderNo"
              name="orderNo"
              type="text"
              autocomplete="on"
              clearable
              size="small"
              maxlength="64"
            />
          </el-form-item>
        </el-col>
      </el-form-item>
      <el-form-item label-width="0">
        <el-col :span="11">
          <el-form-item label="生产日期:" prop="dateCode">
            <el-date-picker
              v-model="form.dateCode"
              type="date"
              size="small"
              style="width: 100%;">
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="11"></el-col>
      </el-form-item>
      <el-form-item :label="$t('common.stylePreview') + ':'" style="margin-bottom: 0">
      </el-form-item>
      <el-form-item>
        <el-col :span="15">
          <iframe
            id="labelIFrameJingTaiLabelDialog"
            scrolling="no"
            width="520"
            height="260"
            frameborder="0"
            style="background: #E9E9E9;"
          ></iframe>
        </el-col>
      </el-form-item>
    </el-form>
    <span slot="footer">
        <el-button size="small" @click="close">{{$t('common.cancel')}}</el-button>
        <el-button
          size="small"
          type="primary"
          @click="submitForm">
            {{$t('common.print')}}
        </el-button>
      </span>
  </el-dialog>
</template>

<script>
  import {
    validateCount,
  } from '@/utils/validate';
  import {
    initJingTaiLabelFrame,
    printFactoryLabel,
  } from '@/utils/factory-label';

  export default {
    name: 'JingTaiLabelDialog',
    props: {
      factoryName: {
        type: String,
        default: '',
      },
      visible: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        form: {
          supplierCode: 'S.03387',
          materialCode: '',
          materialName: '',
          specModel: '',
          qty: '',
          orderNo: '',
          dateCode: '',
        },
        rules: {
          materialCode: [{
            required: true,
            trigger: 'blur',
            message: '物料代码不能为空',
          }],
          materialName: [{
            required: true,
            trigger: 'blur',
            message: '物料名称不能为空',
          }],
          specModel: [{
            required: true,
            trigger: 'blur',
            message: '规格型号不能为空',
          }],
          qty: [{
            required: true,
            trigger: 'blur',
            validator: validateCount
          }],
          orderNo: [{
            required: true,
            trigger: 'blur',
            message: '订单号不能为空',
          }],
          dateCode: [{
            required: true,
            trigger: 'blur',
            message: '生产日期不能为空',
          }],
        },
        flag: false,
      };
    },
    watch: {
      visible(newValue) {
        if (newValue && !this.flag) {
          setTimeout(() => {
            this.renderJingTaiLabelFrame();
          });
          this.flag = true;
        }
      },
    },
    methods: {
      handleDialogClose() {
        this.close();
      },
      close() {
        this.$emit('update:visible', false);
        this.$emit('close');
        if (this.$refs.refForm && typeof this.$refs.refForm.clearValidate === 'function') {
          this.$refs.refForm.clearValidate();
        }
      },
      submitForm() {
        this.$refs.refForm.validate(async (valid) => {
          if (valid) {
            this.printJingTaiLabelFrame();
          }
        });
      },
      renderJingTaiLabelFrame() {
        let iframe = document.getElementById('labelIFrameJingTaiLabelDialog');
        iframe = initJingTaiLabelFrame({
          iframe,
          supplierCode: 'S.03387',
          materialCode: '10101.00245',
          materialName: 'LS9025Y',
          specModel: '全彩单像素LED显示屏恒流驱动芯片',
          qty: '1000',
          orderNo: 'FP0260300231',
          dateCode: '2026-03-19',
        });
        iframe.contentWindow.document.close();
      },
      printJingTaiLabelFrame() {
        const {
          supplierCode,
          materialCode,
          materialName,
          specModel,
          qty,
          orderNo,
          dateCode,
        } = this.form;
        let iframe = document.getElementById('labelIFrameJingTaiLabelDialog');
        iframe = initJingTaiLabelFrame({
          iframe,
          supplierCode,
          materialCode,
          materialName,
          specModel,
          qty,
          orderNo,
          dateCode,
        });
        iframe.contentWindow.document.close();
        printFactoryLabel(iframe);
      },
      printClick() {
        let iframe = document.getElementById('labelIFrameJingTaiLabelDialog');
        iframe.contentWindow.document.close();
        printFactoryLabel(iframe);
      },
    },
  };
</script>

<style scoped>
  .title-container {
    display: flex;
    display: -webkit-flex;
    flex-direction: row;
    justify-content: space-between;
    background: -webkit-linear-gradient(#F9F9F9, #EEEEEE);
    background: -o-linear-gradient(#F9F9F9, #EEEEEE);
    background: -moz-linear-gradient(#F9F9F9, #EEEEEE);
    background: linear-gradient(#F9F9F9, #EEEEEE);
    padding: 10px 15px;
    align-items: center;
  }

  .title-text {
    color: #404040;
    font-size: 16px;
  }

  .el-form {
    margin: 0 30px;
  }

  .close-image {
    width: 22px;
    height: 22px;
    cursor: pointer;
    padding: 0 10px;
  }
</style>
<style>
  .edit-detail-dialog .el-dialog__header {
    padding: 0;
  }
</style>
